
<template>
  <div >
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title class = "heading" v-if="mode==='create'">Create Load</md-dialog-title>
      <md-dialog-title class = "heading" v-if="mode==='update'">Modify Load</md-dialog-title>
      <md-dialog-title class = "heading" v-if="mode==='copy'">Copy Load</md-dialog-title>
      <md-dialog-title class = "heading" v-if="mode==='delete'">Delete Load</md-dialog-title>
      <md-dialog-title class = "heading" v-if="mode==='status'">Change Stauts</md-dialog-title>
      
    

      <md-dialog-content >
        <form id = "top" novalidate @submit.prevent="doSaveUser">
            <!-- <div v-if="mode == 'create' & getPermission.acnit.view">
              <md-card v-if="dataForm.receivingWindows == '185' & getPermission.acnit.view" :class="getValidationRadio('dataForm.scale')">
                <div>CCR Log ID: {{ ccrLog.logId }} </div>
                <md-card-content>
                  <md-radio v-model="dataForm.scale" value="1" @change="onSelect">FSI Scale 1</md-radio>
                  <md-radio v-model="dataForm.scale" value="2" @change="onSelect">FSI Scale 2</md-radio>
                </md-card-content>
              </md-card>

              <md-card v-if="dataForm.receivingWindows == '186' & getPermission.acnit.view" :class="getValidationRadio('dataForm.scale')">
                <div>CCR Log ID: {{ ccrLog.logId }} </div>
                <md-card-content>
                  <md-radio v-model="dataForm.scale" value="3" @change="onSelect">WIL Scale1</md-radio>
                  <md-radio v-model="dataForm.scale" value="4" @change="onSelect">WIL Scale2</md-radio>
                </md-card-content>
              </md-card>
            </div> -->
         

        <div class = "down">

        <div class="layoutPlant"> </div>
   
        <div class = "inputBoxDoubleLoadList">
          <div class = "inputSpace">
            <auto-complete-master-data-select v-if="mode != 'status' && mode != 'delete'" :class="getValidationClass('dataForm.salesOffice')"
                                                group="GST_SALEOFFICE"
                                                label="Sales Office"
                                                :init-value="dataForm.salesOffice"
                                                :disabled=" mode=='delete'"
                                                :on-item-changed="handleSalesOfficeChanged"
                                                >
            </auto-complete-master-data-select>

            <md-field v-if="mode == 'delete'" :class="getValidationClass('dataForm.salesOffice')">
            <label for="salesOffice">Sales Office</label>
            <md-input name="salesOffice"
                      id="salesOffice"
                      autocomplete="new-password"
                      v-model="dataForm.salesOffice"
                      :disabled="mode=='delete' "
            />
          </md-field>

          </div>
          <div class = "inputSpace">
            <div class = "layout">
            <auto-complete-master-data-select v-if="mode != 'status'" :class="getValidationClass('dataForm.source')"
                                                group="GST_SOURCE"
                                                label="Source"
                                                :init-value="dataForm.source"
                                                :on-item-changed="handleSourceChanged"
                                                 :disabled="mode=='delete' "
                                                >
            </auto-complete-master-data-select>
        </div>
          </div>
          
        </div>

        <div class = "inputBoxDoubleLoadList">
           <div class = "inputSpace">
             <md-field>
                <label>Transloading Yard</label>
                <md-input v-model="dataForm.transloadingYard" disabled/>
              </md-field>
          </div>

          <div class = "inputSpace">
             <auto-complete-master-data-select :class="getValidationClass('dataForm.receivingWindows')"
                                                group="REC_WINDOW"
                                                label="Receiving Windows"
                                                :preparedOptions="loaded_recwin"
                                                :init-value="dataForm.receivingWindows"
                                                :on-item-changed="handleWindowsChanged"
                                                 :disabled="mode=='delete'"
                                                >
            </auto-complete-master-data-select>
          </div>
        </div>


        <div class = "inputBoxDoubleLoadList">
           <div class = "inputSpace">
             <auto-complete-master-data-select v-if="mode != 'delete' && mode != 'update'" :class="getValidationClass('dataForm.loadStatus')"
                                                group="GST_LOAD_STATUS"
                                                label="Load Status"
                                                :init-value="dataForm.loadStatus"
                                                :on-item-changed="handleStatusChanged"
                                                >
            </auto-complete-master-data-select>

            <md-field v-if="mode == 'delete'">
            <label for="Load Status">Load Status</label>
            <md-input name="Load Status"
                      id="Load Status"
                      autocomplete="new-password"
                      v-model="dataForm.loadStatus"
                      :disabled="mode=='delete' "
            />
          </md-field>

       
            <auto-complete-master-data-select v-if="mode == 'update'" :class="getValidationClass('dataForm.loadStatus')"
                                                group="GST_LOAD_STATUS"
                                                label="Load Status"
                                                :init-value="dataForm.loadStatus"
                                                :on-item-changed="handleStatusChanged"
                                                :disabled="dataForm.oldloadStatus != 'EPT' && dataForm.oldloadStatus != 'LD' && dataForm.oldloadStatus != 'VD'&& dataForm.source != 'D'"
                                                >
            </auto-complete-master-data-select>

          </div>

          <div class = "inputSpace">
              <auto-complete-master-data-select :class="getValidationClass('dataForm.ctnrType')"
                                                group="CCR_CNTRTYPE"
                                                label="Ctnr Type"
                                                :init-value="dataForm.ctnrType"
                                                :on-item-changed="handleCtnrTypeChanged"
                                                 :disabled="mode=='delete' "
                                                >
            </auto-complete-master-data-select>
          </div>
        </div>




        <div class = "inputBoxDoubleLoadList">
          <div class = "inputSpace">
               <!-- <auto-complete-master-data-select v-if="mode != 'status' && mode != 'delete'" :class="getValidationClass('dataForm.moveInBy')"
                                                :prepared-options="drivers"
                                                label="Move In By"
                                                :init-value="dataForm.moveInBy"
                                                :on-item-changed="handleDriverChanged"
                                                >
            </auto-complete-master-data-select> -->
            <md-field v-if="mode != 'status' " :class="getValidationClass('dataForm.moveInBy')">
            <label for="moveInBy">Move In By</label>
            <md-input name="moveInBy"
                      id="moveInBy"
                      autocomplete="new-password"
                      v-model="dataForm.moveInBy"
                      :disabled="mode=='delete' "
            />
          </md-field>
          </div>

          <div class = "inputSpace">
              <!-- <auto-complete-master-data-select v-if="mode != 'status'" :class="getValidationClass('dataForm.chassisVendor')"
                                                group="GST_CHASSIS"
                                                label="Chassis Vendor"
                                                :init-value="dataForm.chassisVendor"
                                                :on-item-changed="handleChassisVendorChanged"
                                                :disabled="mode=='delete' "
                                                >
            </auto-complete-master-data-select> -->

            <md-field v-if="mode != 'status' " :class="getValidationClass('dataForm.chassisVendor')">
            <label for="chassisVendor">Chassis Vendor</label>
            <md-input name="chassisVendor"
                      id="chassisVendor"
                      autocomplete="new-password"
                      v-model="dataForm.chassisVendor"
                      :disabled="mode=='delete' "
            />
          </md-field>
          </div>
        </div>


       <div class = "inputBoxDoubleLoadList">
         <div class = "inputSpace">
            <div  v-if="mode != 'status' && mode != 'delete'" :class="getValidationClass('dataForm.moveInDate')">
            <datepicker v-model="dataForm.moveInDate">
              <label>Move In Date</label>
               <span class="md-error" v-if="!$v.dataForm.moveInDate.required">Move in date is required<br/></span>
            </datepicker>
        </div>

        <md-field v-if="mode == 'delete'">
              <label for="moveInDate">Move In Date</label>
              <md-input name="moveInDate"
                        id="moveInDate"
                        autocomplete="new-password"
                        v-model="dataForm.moveInDateLocal"
                        :disabled="mode=='delete' "
              />
              </md-field>
          </div>

          <div class = "inputSpace">
              <div v-if="mode != 'status'"  :class="getValidationClass('dataForm.moveInTime')" >
            <md-field>
              <label>Move In Time</label>
              <md-input v-model="dataForm.moveInTime" placeholder="Format: HH:MM:SS" :disabled="mode=='delete' "></md-input>
              <span class="md-error" v-if="!$v.dataForm.moveInTime.required">Move in time is required<br/></span>
              <span class="md-error" v-else-if="!$v.dataForm.moveInTime.add">Move in time format is invalid!<br/></span>
              <!-- <span class="md-error" v-if="this.timeError != null">{{this.timeError}}<br/></span> -->
            </md-field>
        </div>
          </div>
        </div>


      <div class = "inputBoxDoubleLoadList">
         <div class = "inputSpace">
            <div  v-if="mode != 'status' && mode != 'delete'" :class="getValidationClass('dataForm.chzStartDate')">
            <datepicker v-model="dataForm.chzStartDate">
              <label>Chassis Start Date</label>
            </datepicker>
        </div>

        <md-field v-if="mode == 'delete'">
              <label for="moveInDate">Chassis Start Date</label>
              <md-input name="chzStartDate"
                        id="chzStartDate"
                        autocomplete="new-password"
                        v-model="dataForm.chzStartDateLocal"
                        :disabled="mode=='delete' "
              />
              </md-field>
          </div>

          <div class = "inputSpace">
              <div v-if="mode != 'status'"  :class="getValidationClass('dataForm.chzStartTime')" >
            <md-field>
              <label>Chassis Start Time</label>
              <md-input v-model="dataForm.chzStartTime" placeholder="Format: HH:MM:SS" :disabled="mode=='delete' "></md-input>
              <span class="md-error" v-if="!$v.dataForm.chzStartTime.add">Chassis Start time format is invalid!<br/></span>
              <!-- <span class="md-error" v-if="this.timeError != null">{{this.timeError}}<br/></span> -->
            </md-field>
        </div>
          </div>
        </div>

        

        <div class = "inputBoxDoubleLoadList">
          <div class = "inputSpace">
            <md-field v-if="mode != 'status' " :class="getValidationClass('dataForm.containerNo')">
            <label for="containerNo">Container #</label>
            <md-input name="containerNo"
                      id="containerNo"
                      autocomplete="new-password"
                      v-model="dataForm.containerNo"
                      :disabled="mode=='delete' "
                      @keyup="checkISO()"
            />
            <div>
              <div class="md-error" v-if="!$v.dataForm.containerNo.maxLength">Container# length is 11!<br/></div>
              <div class="md-error" v-else-if="!$v.dataForm.containerNo.minLength">Container# min length is 10!<br/></div>
            </div>
          </md-field>
          <div class="ErrorMessage" v-if="notISOContainer">Please check container# not match ISO standard</div>
          <div class="ErrorMessage" v-if="notFormatContainer">Please check container format with 4 chars + (7 digits or 6 digits)</div>
          </div>

          <!-- <div class = "inputSpace">
            <md-field v-if="mode != 'status'" :class="getValidationClass('dataForm.chassisNo')">
              <label for="chassisNo">Chassis #</label>
              <md-input name="chassisNo"
                        id="chassisNo"
                        autocomplete="new-password"
                        v-model="dataForm.chassisNo"
                        :disabled="mode=='delete' "
              />
              <div>
                <div class="md-error" v-if="!$v.dataForm.chassisNo.maxLength">Container length is between 9 and 15!<br/></div>
                <div class="md-error" v-else-if="!$v.dataForm.chassisNo.minLength">Container length is between 9 and 15!<br/></div>
              </div>
            </md-field>
          </div> -->


          <div class = "inputSpace">


            <md-field v-if="mode != 'status' " :class="getValidationClass('dataForm.chassisNo')">
              <label for="chassisNo">chassisNo</label>
              <md-input name="chassisNo"
                        id="chassisNo"
                        autocomplete="new-password"
                        v-model="dataForm.chassisNo"
                        :disabled="mode=='delete' "
              />
            </md-field>
            

              <!-- <AutocompleteSelect
                  label="chassisNo"
                  group="GST_LEASECHASSIS"
                  v-model="dataForm.chassisNo"
                  :on-item-selected="handleChassisChanged"
                  :disabled="mode=='delete' "
                  
              /> -->


            <div class="md-error" v-if="!$v.dataForm.chassisNo.required">Chassis# is required!<br/></div>
            <!-- <div class="md-error" v-if="!$v.dataForm.chassisNo.maxLength">Chassis length is between 9 and 15!<br/></div>
            <div class="md-error" v-else-if="!$v.dataForm.chassisNo.minLength">Chassis length is between 9 and 15!<br/></div> -->
          </div>
        </div>


        
        
       <div class = "inputBoxDoubleLoadList">
        <div class = "inputCheckBoxWide">
            <md-field v-if="mode != 'status'" :class="getValidationClass('dataForm.ownChassis')">
            <label for="ownChassis"> {{dataForm.ownChassis == "YES" ? "Company Own Chassis(YES)" : "Non Own Chassis(NO)"}}</label>
            <md-input name="ownChassis"
                      id="ownChassis"
                      autocomplete="new-password"
                      :disabled="true"
            />
             <md-checkbox v-model="dataForm.ownChassis" 
             value="YES"
             :disabled="mode=='delete'">
                        <span></span>
              </md-checkbox>
          </md-field>
        </div>
        </div>


        <div class = "inputBoxDoubleLoadList">
          <div class = "inputBoxWide">
       
          <!-- <auto-complete-master-data-select v-if="mode != 'status' && mode != 'delete'" :class="getValidationClass('dataForm.carrier')"
                                                group="GST_CARRIER"
                                                label="Ocean Carrier"
                                                :init-value="dataForm.carrier"
                                                :disabled=" mode=='delete'"
                                                :on-item-changed="handleCarrierChanged"
                                                >
          </auto-complete-master-data-select> -->
          <!--
          <AutocompleteSelect
                label="Ocean Carrier"
                group="STC_CARRIER"
                v-model="dataForm.carrier"
                :disabled=" mode=='delete'"
                :on-item-selected="handleCarrierChanged"
            />
          -->
          <auto-complete-master-data-select v-if="mode != 'status' && mode != 'delete'" :class="getValidationClass('dataForm.carrier')"
                       label="Ocean Carrier"
                       :prepared-options="this.getActiveCarrir()"
                       :init-value-id="dataForm.carrier"
                       :on-item-changed="handleCarrierChanged">
                       :disabled="mode=='delete'"
                   </auto-complete-master-data-select>


          <md-field v-if="mode == 'delete'" :class="getValidationClass('dataForm.carrier')">
            <label for="carrier">Ocean Carrier</label>
            <md-input name="carrier"
                      id="carrier"
                      autocomplete="new-password"
                      v-model="dataForm.carrier"
                      :disabled="mode=='delete'"
            />
          </md-field>

         </div>
        </div>

        <div class = "inputBoxDoubleLoadList">
          <div class = "inputBoxWide">
          <div v-if="mode != 'status' && mode != 'delete'">
            <autocomplete-ccic-location-select
                label="Pickup Loc"
                group="STC_TERMINAL"
                v-model="dataForm.pickupLocation"
                :on-item-selected="handlePickLocationChanged"
            />
          </div>

            <md-field v-if="mode == 'delete'">
            <label for="pickupLocation">Pickup Loc</label>
            <md-input name="pickupLocation"
                      id="pickupLocation"
                      autocomplete="new-password"
                      v-model="dataForm.pickupLocation"
                      :disabled="mode=='delete'"
            />
          </md-field>
          <master-data-display v-if="dataForm.pickupLocation != null" group="STC_TERMINAL" :tag-id="dataForm.pickupLocation"/>
         </div>
        </div>

        
        <div class = "inputBoxDoubleLoadList">
          <div class = "inputSpace">
          

              <md-field v-if="mode != 'status'" :class="getValidationClass('dataForm.yard')">
                <label for="yard">Yard</label>
                <md-input name="yard"
                          id="yard"
                          autocomplete="new-password"
                          v-model="dataForm.yard"
                          :disabled="mode=='delete' "
                />
              </md-field>

            </div>

            <!-- <div class = "inputSpace">
              <md-field v-if="mode != 'status'" :class="getValidationClass('dataForm.locationNumber')">
                <label for="locationNumber">Customer</label>
                  <md-input name="locationNumber"
                            id="locationNumber"
                            autocomplete="new-password"
                            v-model="dataForm.locationNumber"
                            :disabled="mode=='delete' "
                  />
              </md-field>
            </div> -->

              <div class = "inputSpace">
                <auto-complete-master-data-select :class="getValidationClass('dataForm.locationNumber')"
                  group="STC_CUSTOMER" label="Container Customer" :init-value="dataForm.locationNumber" :on-item-changed="handleCustIDChanged">
                </auto-complete-master-data-select>
              </div>

          </div>

          <div class = "inputBoxDoubleLoadList">
            <div class = "inputSpace">
              <md-field v-if="mode != 'status'" :class="getValidationClass('dataForm.scac')">
                    <label for="scac">Carrier SCAC</label>
                    <md-input name="scac"
                            id="scac"
                            autocomplete="new-password"
                            v-model="dataForm.scac"
                            disabled
                    />
                </md-field>
            </div>

            <div class = "inputSpace">
              <md-field v-if="mode != 'status'" :class="getValidationClass('dataForm.poolContract')">
              <label for="poolContract">Pool Contract</label>
              <md-input name="poolContract"
                        id="poolContract"
                        autocomplete="new-password"
                        v-model="dataForm.poolContract"
                        :disabled="mode=='delete' "
              />
              </md-field>
            </div>
          </div>         
        </div>

        <div class = "alwaysShow">
          <callingApiCenter type="bar" :paths="['/api/w/gst/loadlist/create','/api/w/users','/api/w/gst/loadlist', '/api/w/gst/createyardstage']"></callingApiCenter>
          <div v-if="mode==='create'">
            <md-dialog-actions >
              <md-button class="md-raised custButtonForm " @click="cancalAction"><span class="icons-center material-icons">cancel</span>Close</md-button>
              <md-button type="submit" class="md-raised custButtonForm "><span class="icons-center material-icons">create</span>Create</md-button>
            </md-dialog-actions>
          </div>
        

          <div v-if="mode==='update'">
            <md-dialog-actions>
              <md-button class="md-raised custButton" @click="cancalAction"><span class="icons-center material-icons">cancel</span>Close</md-button>
              <md-button type="submit" class="md-raised custButton"><span class="icons-center material-icons">update</span>Save</md-button>
            </md-dialog-actions>
          </div>

        <calling-api v-if="mode==='copy'">
            <md-dialog-actions>
              <md-button class="md-raised custButton" @click="cancalAction"><span class="icons-center material-icons">cancel</span>Close</md-button>
              <md-button type="submit" class="md-raised custButton"><span class="icons-center material-icons">file_copy</span>Copy</md-button>
            </md-dialog-actions>
          </calling-api>


        <calling-api v-if="mode==='delete'">
            <md-dialog-actions>
              <md-button class="md-raised custButton " @click="cancalAction"><span class="icons-center material-icons">cancel</span>Close</md-button>
              <md-button type="submit" class=" custButton redButton "><span class="icons-center material-icons">delete</span>Delete</md-button>
            </md-dialog-actions>
          </calling-api>


        <calling-api v-if="mode==='status'">
            <md-dialog-actions>
              <md-button class="md-raised custButton" @click="cancalAction"><span class="icons-center material-icons">cancel</span>Close</md-button>
              <md-button type="submit" class="md-raised custButton"><span class="icons-center material-icons">cancel</span>Save</md-button>
            </md-dialog-actions>
          </calling-api>
        </div>
      </form>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>


<style scoped>


.container {
  display: flex;
  flex-direction: row;
  margin: auto;
  width: 300px;
}

.layoutPlant {
  padding-top: 0;
  padding-left: 0;
  padding-bottom: 0;
  width: 20%;
  line-height: 1.5;
  color: black;
  background-color: rgb(185, 218, 237);
  display: inline-block;
  font-family: Roboto Slab;
  margin: auto;
}

.layoutScale {
  padding-top: 0;
  padding-left: 0;
  padding-bottom: 0;
  font-family: Roboto Slab;
  margin: auto;
}

  form {
    min-width: 560px;
    margin: 24px;
  }
  
  .alwaysShow {
    position: fixed;
    right: 60px;
    top : 30px;
  }

  
  .redButton{
    background-color: #c50000;
    z-index: 4;
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
  }


  .icons-center {
    vertical-align: middle;
    margin-right: 10px;
  }

  .custButtonForm {
    margin: 0px;
    width: 100px;
    height: 30px;
    line-height: 20px;
    font-size: 0.7rem; 
  }

  .heading{
    padding-top: 30px;
    margin-bottom: 0;
    color: #555555;
    width: 92%;
    line-height: 1;
    font-size: 26px;
    font-family: Roboto Slab;
    margin-left: 60px;
  }

  .layout{
    margin-top: 0px;
    margin-bottom: 0px;
    padding-top: 0px;
    padding-bottom: 0px;
    width: 92%;
    line-height: 0;
    color: #555555;
    font-family: Roboto Slab;
    margin: auto;
  }


  .inputBoxDoubleLoadList {
  width: 500px;
  justify-content: space-around;
  display: flex;
  flex-direction: row;
  margin: auto;
}

.inputSpace {
  color: #29303b;
  font-size: 18px;
  height: auto;
  width: 200px;
  line-height: 1em;
}

.inputBoxWide {
  color: #29303b;
  font-size: 18px;
  height: auto;
  width: 450px;
  line-height: 1em;
}

.inputCheckBoxWide {
  color: #29303b;
  font-size: 18px;
  height: auto;
  width: 450px;
  line-height: 1em;
}

.ErrorMessage {
  color: #f14668 !important;
  font-size: 12px;
}

</style>

<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  import { minLength, required , maxLength} from 'vuelidate/lib/validators';
  import AutocompleteCcicLocationSelect from "./AutocompleteCcicLocationSelect.vue";
  import AutocompleteSelect from "./AutoCompleteDebounceSelect.vue";
  import callingApiCenter from "../components/CallingApiCenter.vue";
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';
  import moment from 'moment';

  const getInitialdataForm = () => ({
    salesOffice: null,
    source: null,
    transloadingYard: null,
    receivingWindows: null,
    ctnrType: null,
    containerNo: null,
    oldcontainerNo: null,
    chassisNo: null,
    oldchassisNo: null,
    ownChassis: null,
    chassisVendor: null,
    carrier: null,
    pickupLocation: null,
    moveInDate: null,
    moveInDateLocal: null,
    moveInTime: "00:00:00",
    chzStartDate: null,
    oldchzStartDate: null,
    chzStartDateLocal: null,
    chzStartTime: "00:00:00",
    moveInBy: null,
    loadStatus: "EPT",
    oldloadStatus: "EPT",
    scac:null,
    yard: null,
    locationNumber: null,
    poolContract: null,
    fallbackStart: null,
    fallbackEnd: null,
    chzDefault: false,
    scale: null,
    deliveryOrder: null,
    minmoveindate: null,
    maxmoveindate: null, 
  });

const getInitSearchRequest = () => ({
  yard: null,
  gateType: "S",
  gateNo: null,
  statusType: null,
  logDateTime: {
    startDate: null,
    endDate: null
  },
  logStatus: null
});

const getInitCcrLog = () => ({
  office: "LGB",
  logId: null,
  yard: null,
  gateType: null,
  gateNo: null,
  statusType: null,
  logDateTime: null,
  plateNo: null,
  plateImage: null,
  containerNo: null,
  containerType: null,
  containerImage: null,
  chassisNo: null,
  chassisImage: null,
  scaleWeight: null,
  processType: null,
  inboundShipment: null,
  seqNo: null,
  date: null,
  time: null,
});

  const getInitChassis = () => ({
    salesOffice: null,
    agreement: null
  });


  export default {
    components: { AutocompleteCcicLocationSelect ,callingApiCenter,AutocompleteSelect},
    mixins: [validationMixin],
    props: {
      mode: String,
      action: Function,
    },
    data: () => ({
      showDialog: false,
      dataForm: getInitialdataForm(),
      loadList: [],
      drivers:[],
      timeError: null,
      dispatchers: [],
      ccicQcUsers: [],
      ccrLog: getInitCcrLog(),
      result: getInitCcrLog(),
      searchRequest: getInitSearchRequest(),
      searchRequestChassis: getInitChassis(),
      loadstatuserrormessage: '', 
      notISOContainer: false,
      notFormatContainer: false,
      loaded_recwin: [],
    }),

    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        "getMasterDataByGroup",
        'getMasterDataName',
        'getUserProfile',
        'getPermission',
      ]),

      // canChangestatus() {
      //   return this.dataForm.oldloadStatus === 'EPT' && this.dataForm.oldloadStatus === 'LD';
      // },
      
    },


    validations: {
      dataForm: {
        salesOffice: {
          required,
        },
        source: {
            required,
        },
        transloadingYard: {
            required,
        },
        receivingWindows: {
            required,
        },
        ctnrType: {
            required,
        },

        

        containerNo: {
            minLength: minLength(10),
            maxLength: maxLength(11),
        },
        chassisNo: {
            required,
            minLength: minLength(9),
            maxLength: maxLength(15),
        },
        moveInDate:{
                required,
        },
        moveInTime:{
            required,
            add : (value) => {
              
              const res = moment('2021-04-01T' + value).toDate();
              return res != 'Invalid Date';
            }
        },
        chzStartTime:{
            add : (value) => {
              console.log(value);
              if (value == null || value == '') 
              {
                return true
              }
              else
              {
                const res = moment('2021-04-01T' + value).toDate();
                return res != 'Invalid Date';
              }
              
            }
        },
        loadStatus:{
            required,
        },

        ownChassis: {}, 
        scac: {}, 
        chassisVendor:{}, 
        carrier:{}, 
        pickupLocation:{}, 
        moveInBy:{}, 
        yard:{}, 
        locationNumber:{}, 
        poolContract: {},
      },
    },


    methods: {
     async openDialog(existingUser) {
        this.$store.commit('clearApiError');
        this.$v.dataForm.$reset();
        console.log(this.$v.dataForm.$invalid);
        this.dataForm = getInitialdataForm();
        this.ccrLog = getInitCcrLog();
        this.dataForm.chzDefault = false;
        this.dataForm.username = this.getUserProfile.username;
        this.dataForm.transloadingYard = '1010001';

        var p_loaded_recwin = this.getMasterDataByGroup('REC_WINDOW');
        if (p_loaded_recwin.length > 0)
        {
          if (!this.getPermission.stc.view)
          {
              this.loaded_recwin = p_loaded_recwin.filter( it => it.tagName != 'STC');
          } else {
              this.loaded_recwin = p_loaded_recwin;
          }
          console.log(`inbound rec win1 : ${JSON.stringify(this.loaded_recwin)}`);

        } else {
          //this.inbound_recwin = api.post('/api/w/masterData', {groups: ['REC_WINDOW']}).filter( it => it.tagName != 'STC');
          //api.post('/api/w/masterData', {groups: ['REC_WINDOW']})
          newAPIPost('/api/w/masterData', {groups: ['REC_WINDOW']})
            .then((res) => {
                p_loaded_recwin = res.filter(it => it.tagName != 'STC' && it.active);
                p_loaded_recwin.forEach((it) => {
                  it.id = it.tagId;
                  it.name = it.tagName;
                  if (this.getPermission.stc.view)
                  {
                    this.loaded_recwin.push(it);
                  }
                })
                console.log(`inbound rec win: ${JSON.stringify(this.inbound_recwin)}`);
          });
        }


        if (existingUser && this.mode === 'create' ) {
          this.dataForm.salesOffice = existingUser.salesOffice;
          this.dataForm.receivingWindows = existingUser.receivingWindows;    
          this.dataForm.deliveryOrder = existingUser.deliveryOrder;
        }

        if (existingUser && this.mode === 'update' ) {
          this.dataForm.seqNo = existingUser.seqNo;
          this.dataForm.salesOffice = existingUser.salesOffice;
          this.dataForm.source = existingUser.source;
          this.dataForm.transloadingYard = existingUser.transloadingYard;
          this.dataForm.receivingWindows = existingUser.receivingWindows;
          this.dataForm.ctnrType = existingUser.ctnrType;
          this.dataForm.containerNo = existingUser.containerNo;
          this.dataForm.oldcontainerNo = existingUser.containerNo;
          this.dataForm.chassisNo = existingUser.chassisNo;
          this.dataForm.oldchassisNo = existingUser.chassisNo;
          this.dataForm.ownChassis =  existingUser.ownChassis;
          this.dataForm.chassisVendor = existingUser.chassisVendor;
          this.dataForm.carrier = existingUser.carrier;
          this.dataForm.pickupLocation = existingUser.pickUpLocation;
          this.dataForm.moveInDate = dateFormat.date(existingUser.moveInDate);
          this.dataForm.moveInTime = dateFormat.time(existingUser.moveInDate);
          this.dataForm.chzStartDate = dateFormat.date(existingUser.chzStartDate);
          this.dataForm.oldchzStartDate = dateFormat.date(existingUser.chzStartDate);
          this.dataForm.chzStartTime = dateFormat.time(existingUser.chzStartDate);
          this.dataForm.moveInBy = existingUser.moveInBy;
          this.dataForm.loadStatus = existingUser.loadStatus;
          this.dataForm.oldloadStatus = existingUser.loadStatus;
          this.dataForm.scac = existingUser.scac;
          this.dataForm.yard = existingUser.yard;
          this.dataForm.locationNumber = existingUser.locationNumber;
          this.dataForm.poolContract = existingUser.poolContract;
          this.dataForm.deliveryOrder = existingUser.deliveryOrder;
          
        }


        if (existingUser && this.mode === 'status') {
          this.loadList = existingUser;
        }




        if (existingUser && this.mode === 'copy') {
          this.dataForm.seqNo = existingUser.seqNo;
          this.dataForm.salesOffice = existingUser.salesOffice;
          this.dataForm.source = existingUser.source;
          this.dataForm.transloadingYard = existingUser.transloadingYard;
          this.dataForm.receivingWindows = existingUser.receivingWindows;
          this.dataForm.ctnrType = existingUser.ctnrType;
          this.dataForm.containerNo = existingUser.containerNo;
          this.dataForm.chassisNo = existingUser.chassisNo;
          this.dataForm.ownChassis =  existingUser.ownChassis;
          this.dataForm.scac = existingUser.scac;
          this.dataForm.chassisVendor = existingUser.chassisVendor;
          this.dataForm.carrier = existingUser.carrier;
          this.dataForm.pickupLocation = existingUser.pickUpLocation;
          // this.dataForm.moveInDate = dateFormat.date(existingUser.moveInDate);
          this.dataForm.moveInDate = dateFormat.date(moment().add(0,'days').endOf('d').toDate());
          this.dataForm.moveInTime = dateFormat.time(existingUser.moveInDate);
          this.dataForm.moveInBy = existingUser.moveInBy;
          // this.dataForm.chzStartDate = dateFormat.date(existingUser.chzStartDate);
          this.dataForm.chzStartDate = dateFormat.date(moment().add(0,'days').endOf('d').toDate());
          this.dataForm.chzStartTime = dateFormat.time(existingUser.chzStartDate);
          // this.dataForm.loadStatus = existingUser.loadStatus;
          this.dataForm.loadStatus = 'EPT';
          this.dataForm.yard = existingUser.yard;
          this.dataForm.locationNumber = existingUser.locationNumber;
          this.dataForm.poolContract = existingUser.poolContract;
        }


        if (existingUser && this.mode === 'delete') {
         this.dataForm.seqNo = existingUser.seqNo;
          this.dataForm.salesOffice = existingUser.salesOffice;
          this.dataForm.source = existingUser.source;
          this.dataForm.transloadingYard = existingUser.transloadingYard;
          this.dataForm.receivingWindows = existingUser.receivingWindows;
          this.dataForm.ctnrType = existingUser.ctnrType;
          this.dataForm.containerNo = existingUser.containerNo;
          this.dataForm.chassisNo = existingUser.chassisNo;
          this.dataForm.ownChassis =  existingUser.ownChassis;
          this.dataForm.scac = existingUser.scac;
          this.dataForm.chassisVendor = existingUser.chassisVendor;
          this.dataForm.carrier = existingUser.carrier;
          this.dataForm.pickupLocation = existingUser.pickUpLocation;
          this.dataForm.moveInDate = dateFormat.date(existingUser.moveInDate);
          this.dataForm.moveInTime = dateFormat.time(existingUser.moveInDate);
          this.dataForm.moveInBy = existingUser.moveInBy;
          this.dataForm.chzStartDate = dateFormat.date(existingUser.chzStartDate);
          this.dataForm.chzStartTime = dateFormat.time(existingUser.chzStartDate);
          this.dataForm.loadStatus = existingUser.loadStatus;
          this.dataForm.yard = existingUser.yard;
          this.dataForm.locationNumber = existingUser.locationNumber;
          this.dataForm.poolContract = existingUser.poolContract;
          this.dataForm.moveInDateLocal = dateFormat.gstDateFormat(existingUser.moveInDate);
        }

        this.notISOContainer = false;
        this.notFormatContainer = false;
        this.showDialog = true;
        // this.drivers = [];
        // await this.$store.dispatch('getUsersByCategory', { category: 'L' })
        // .then((res) => {
        //   this.drivers = res;
        // });
      },

      handleCustIDChanged(id, name){
          console.log(`handleCustIDChanged`, id, name);
        this.dataForm.locationNumber = id;
      },

    onSelect() {
      console.log("CCR Create Container");
      this.readAction();
    },

    getValidationRadio(fieldName) {
      const field = _(this.$v).lookup(fieldName);

      if (field) {
        return {
          ErrorMessage: field.$invalid && field.$dirty,
        };
      }
      return {};
    },

    getActiveCarrir() {
       const carrier = this.getMasterDataAsSelectOptionByGroup('STC_CARRIER');
       //console.log("active carrier: " + JSON.stringify(carrier));
       return carrier;
    },

    readAction() {
      this.getCCRLog(this.dataForm);
    },

    async getCCRLog(LogCcr) {
      this.ccrLog = getInitCcrLog();
      this.result = getInitCcrLog();

      if (LogCcr == null) return;
      const scaleDate = dateFormat.getLocalDateOnly(moment().toDate())
      this.searchRequest.yard = LogCcr.yard;
      this.searchRequest.statusType = "S";
      this.searchRequest.gateNo = LogCcr.scale; 
      this.searchRequest.logDateTime.startDate = scaleDate + "T00:00:01";
      this.searchRequest.logDateTime.endDate = scaleDate + "T23:59:59";

      const search = this.searchRequest;

      if (LogCcr.scale != null)
      {
        //this.result = await api.post('/api/w/ccr/data/getCCRLog', search);
        this.result = await newAPIPost('/api/w/ccr/data/getCCRLog', search);
        this.result.sort((a,b) => new Date(b.logDateTime) - new Date(a.logDateTime));
        this.ccrLog = this.result[0];
        this.dataForm.containerNo = this.ccrLog.containerNo;
        this.dataForm.ctnrType = this.ccrLog.containerType;
        this.dataForm.chassisNo = this.ccrLog.chassisNo;
        this.dataForm.moveInDate = moment(String(this.ccrLog.logDateTime)).format('MM/DD/YYYY');
        this.dataForm.moveInTime = moment(String(this.ccrLog.logDateTime)).format('hh:mm:ss');
 
      };
    },



      handlePickLocationChanged(item) {
        if (item) {
          this.dataForm.pickupLocation = item.tagId;
        } else {
          this.dataForm.pickupLocation = null;
        }
      },

      handleWindowsChanged(id) {
        this.dataForm.receivingWindows = id;
    },


    handleCtnrTypeChanged(id) {
      this.dataForm.ctnrType = id;
    },


       handleSalesOfficeChanged(id) {
        this.dataForm.salesOffice = id;
      },

      handleSourceChanged(id) {
        this.dataForm.source = id;
      },

      handleChassisVendorChanged(id) {
        this.dataForm.chassisVendor = id;
      },



      //handleCarrierChanged({id,tagName}) {
      handleCarrierChanged(id) {
        //console.log("carrier id: " + id);
        const selectedCarrier = this.getActiveCarrir().filter(it => it.tagId == id);
        var tagname = null;
        if (selectedCarrier && selectedCarrier.length > 0) {
           tagname = selectedCarrier[0].tagName
        }
        //console.log("all carriers: " + JSON.stringify(tagname));
        this.dataForm.carrier = tagname;
        this.dataForm.scac = id;
      },


      // handleChassisChanged({id,tagName}) {
      //   console.log(id);
      //   console.log(tagName);
      //   // this.dataForm.chassisNo = tagName;
      //   if (tagName != null )
      //   {
      //     this.dataForm.ownChassis = "YES";
      //     this.dataForm.chassisVendor = tagName;
      //   }

      //   if (tagName == null )
      //   {
      //     this.dataForm.ownChassis = " ";
      //     this.dataForm.chassisVendor = " ";
      //   }

      // },

       handleScacChanged(id) {
        //this.dataForm.scac = id;
      },


      handleDriverChanged(id) {
        this.dataForm.moveInBy = id;
      },

      async checkISO() {
        this.notISOContainer = false;
        this.notFormatContainer = false;
        const containerRegex = /^[A-Z]{4}[0-9]{7}$/;
        const Container3rdPartyRegex = /^[A-Z]{4}[0-9]{6}$/;;
        //console.log("containerNo: " + this.dataForm.containerNo);
        if (!Container3rdPartyRegex.test(this.dataForm.containerNo))
        {
          console.log("check ISO" + this.dataForm.containerNo);
          if (this.dataForm.containerNo && this.dataForm.containerNo != "" 
             && this.dataForm.containerNo.length == 11) {
               //alert("check container#: " + this.dataForm.containerNo);
               if (!containerRegex.test(this.dataForm.containerNo.toUpperCase())) {
                  this.notFormatContainer = true;
                  return;
               }
               const org_checkdigit = this.dataForm.containerNo.slice(10,11);
               var checkdigit = "";
               //await api.post("/api/w/GetContainerISOCheckDigit", {containerNo: this.dataForm.containerNo})
               await newAPIPost("/api/w/GetContainerISOCheckDigit", {containerNo: this.dataForm.containerNo})
                       .then((retVal) =>{
                           //console.log("retVal: " + JSON.stringify(retVal));
                           checkdigit = retVal
                       })
               //console.log("checkdigit: " + checkdigit);
               if (org_checkdigit != checkdigit)
                   this.notISOContainer = true;  
          } else if (this.dataForm.containerNo.length != 11 || this.dataForm.containerNo.length != 6) {
                this.notFormatContainer = true;
          }
        }  
      },
      
      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },

      handleStatusChanged(id, name) {
        console.log(`handleStatusChanged`, id, name);
        this.dataForm.loadStatus = id;
        //this.dataForm.loadStatus = name;
      },

     cancalAction(){
        this.showDialog = false;
         this.$store.commit('clearApiError');
     },


      doSaveUser() {
        this.timeError = null;
        this.$v.dataForm.$touch();
        this.dataForm.fallbackStart = moment().subtract(1,'months').startOf('d').toDate();
        this.dataForm.fallbackEnd = moment().endOf('d').toDate();
        this.dataForm.minmoveindate = dateFormat.getLocalDateOnly (moment().subtract(6,'months').startOf('d').toDate());
        this.dataForm.maxmoveindate = dateFormat.getLocalDateOnly(moment().add(1,'months').startOf('d').toDate());

       // console.log(`minmoveindate is `, this.dataForm.minmoveindate, `maxmoveindate is ` ,
       //    this.dataForm.maxmoveindate, `move in date is ` , dateFormat.getLocalDateOnly(this.dataForm.moveInDate) , this.mode);
        
        if (this.mode=='create' || this.mode=='copy')
        {
            this.dataForm.action = "CREATE";
        }

         if (this.mode=='update')
        {
          if (this.dataForm.oldloadStatus !=  this.dataForm.loadStatus &&  ( this.dataForm.loadStatus == 'BLC' || this.dataForm.loadStatus == 'CFM' || this.dataForm.loadStatus == 'LOK') && this.dataForm.source !== 'D')
          {
            this.loadstatuserrormessage = 'Load status can not manually change to : ' +  this.dataForm.loadStatus ; 
            window.confirm(this.loadstatuserrormessage)
            return;
          }
          
          if (this.dataForm.oldcontainerNo != this.dataForm.containerNo || this.dataForm.oldchassisNo != this.dataForm.chassisNo || this.dataForm.oldchzStartDate != this.dataForm.chzStartDate || this.dataForm.oldloadStatus != this.dataForm.loadStatus)
            {
              console.log(`Container data changelog old`, this.dataForm.oldcontainerNo ,this.dataForm.oldchassisNo , this.dataForm.oldchzStartDate ,this.dataForm.oldloadStatus);
              console.log(`Container data changelog new`, this.dataForm.containerNo ,this.dataForm.chassisNo , this.dataForm.chzStartDate ,this.dataForm.loadStatus);
            }

   

            this.dataForm.action = "MODIFY";
        }
       
        if (this.mode=='create' || this.mode=='copy' || this.mode=='update' )
        {
          if (dateFormat.getLocalDateOnly(this.dataForm.moveInDate) < this.dataForm.minmoveindate || dateFormat.getLocalDateOnly(this.dataForm.moveInDate) > this.dataForm.maxmoveindate)
           {
            this.loadstatuserrormessage = 'Move in date ' +  dateFormat.date(this.dataForm.moveInDate)  + ' is not correct, please check! : '; 
            window.confirm(this.loadstatuserrormessage)
            return;
          }
        }

        if (this.mode=='delete')
        {
            this.dataForm.action = "DELETE";
        }




        // this.searchRequestChassis.salesOffice = this.dataForm.salesOffice;
        // this.searchRequestChassis.agreement = this.dataForm.agreement;
        // if (this.searchRequestChassis.agreement != null){
        //   const agrementResult = await api.post('/api/w/gst/gstpriceagreement/search', this.searchRequest)
        //     if ( agrementResult.length < 1 ){
        //       window.confirm('Rate Agreement number ' + this.dataForm.agreement + ' not found!')
        //         return;
        //     };
        // }

       //console.log("to save carrier: " + this.dataForm.carrier);

       this.dataForm.salesOffice = this.dataForm.salesOffice == null ? this.dataForm.salesOffice : this.dataForm.salesOffice.toUpperCase();
       this.dataForm.source = this.dataForm.source == null ? this.dataForm.source : this.dataForm.source.toUpperCase();
       this.dataForm.containerNo = this.dataForm.containerNo == null ? this.dataForm.containerNo : this.dataForm.containerNo.toUpperCase();    
       this.dataForm.chassisNo = this.dataForm.chassisNo == null ? this.dataForm.chassisNo : this.dataForm.chassisNo.toUpperCase();
       this.dataForm.scac = this.dataForm.scac == null ? this.dataForm.scac : this.dataForm.scac.toUpperCase();
       this.dataForm.chassisVendor = this.dataForm.chassisVendor == null ? this.dataForm.chassisVendor : this.dataForm.chassisVendor.toUpperCase();
       this.dataForm.carrier = this.dataForm.scac == null ? this.dataForm.scac : this.dataForm.scac.toUpperCase();
       this.dataForm.pickupLocation = this.dataForm.pickupLocation == null ? this.dataForm.pickupLocation : this.dataForm.pickupLocation.toUpperCase();
       this.dataForm.moveInBy = this.dataForm.moveInBy == null ? this.dataForm.moveInBy : this.dataForm.moveInBy.toUpperCase();
       this.dataForm.yard = this.dataForm.yard == null ? this.dataForm.yard : this.dataForm.yard.toUpperCase();
       this.dataForm.locationNumber = this.dataForm.locationNumber == null ? this.dataForm.locationNumber : this.dataForm.locationNumber.toUpperCase();

        console.log(`doSaveUser , invalid=${this.$v.dataForm.$invalid}`);
        // console.log(`Form data is ${JSON.stringify(this.dataForm)}`);

        if (this.$v.dataForm.$invalid) {
        //  this.$refs.top.$el.focus();
          return;
        }
        
        const timeRef = moment('2021-04-01T' + this.dataForm.moveInTime).format('HH:mm:ss');
        this.dataForm.moveInDate = dateFormat.getLocalDateOnly(this.dataForm.moveInDate) + 'T' + timeRef;

        if (this.dataForm.chzStartDate == null || this.dataForm.chzStartDate == '')
        {
          this.dataForm.chzDefault = true
        }
        else
        {
          if (this.dataForm.chzStartTime == null || this.dataForm.chzStartTime == '')
          {
            const timeRefChassis = moment('2021-04-01T' + this.dataForm.moveInTime).format('HH:mm:ss');
            this.dataForm.chzStartDate = dateFormat.getLocalDateOnly(this.dataForm.chzStartDate) + 'T' + timeRefChassis;
          }
          else
          {
            const timeRefChassis = moment('2021-04-01T' + this.dataForm.chzStartTime).format('HH:mm:ss');
            this.dataForm.chzStartDate = dateFormat.getLocalDateOnly(this.dataForm.chzStartDate) + 'T' + timeRefChassis;
          }
        }


        console.log(`Form data is ${JSON.stringify(this.dataForm)}`);
      
        //api.post("/api/w/gst/loadlist/create", this.dataForm)
        newAPIPost("/api/w/gst/loadlist/create", this.dataForm)
          .then((item) => {
            this.$store.commit('clearApiError');
            this.showDialog = false;
            // $('.btn-search-loadlist-container')
            //   .click();
             this.action(item.loadKey || item.seqNo, this.mode);
          });
      },
    },
  };
</script>
